import { render, staticRenderFns } from "./CompletedParent.vue?vue&type=template&id=4a807b09&"
import script from "./CompletedParent.vue?vue&type=script&lang=js&"
export * from "./CompletedParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports